<template>
  <div class="diff-item-renderer">
    <template v-if="value !== null">
      <template v-if="type === 'title'">
        {{ value }}
      </template>
      <template v-else-if="type === 'status'">
        <a-tag v-if="problemStatus[value]" :color="problemStatus[value].color">
          {{ problemStatus[value].label }}
        </a-tag>
        <span v-else>--</span>
      </template>
      <template v-else-if="type === 'urgency'">
        <a-tag v-if="problemUrgencys[value]" :color="problemUrgencys[value].color">
          {{ problemUrgencys[value].label }}
        </a-tag>
        <span v-else>--</span>
      </template>
      <template v-else-if="type === 'channel'">
        {{ problemChannels[value]?.label || '--' }}
      </template>
      <template v-else-if="type === 'frequency'">
        <a-tag v-if="problemFrequencys[value]" :color="problemFrequencys[value].color">
          {{ problemFrequencys[value].label }}
        </a-tag>
        <span v-else>--</span>
      </template>
      <template v-else-if="type === 'level'">
        <a-tag v-if="faultLevels[value]" :color="faultLevels[value].color">
          {{ faultLevels[value].label }}
        </a-tag>
        <span v-else>--</span>
      </template>
      <template v-else-if="['content', 'attribution', 'summary'].includes(type)">
        <a @click="onPreview">{{ previewText }}</a>
      </template>
      <template v-else-if="type === 'problem_type'">
        <a-badge v-if="problemTypes[value]" :color="problemTypes[value].color" :text="problemTypes[value].label" />
        <span v-else>--</span>
      </template>
      <template v-else-if="['tags', 'domains', 'projects'].includes(type)">
        {{ formatArrayValue }}
      </template>
      <template v-else-if="['handler', 'reporter', 'solver'].includes(type)">
        {{ value.nickname || '--' }}
      </template>
      <template v-else-if="['started_time', 'reported_time', 'resolved_time', 'discovered_time', 'located_time', 'confirmed_time'].includes(type)">
        {{ value }}
      </template>
      <template v-else>--</template>
    </template>
    <span v-else>--</span>
  </div>
</template>

<script>
import { problemUrgencys, problemChannels, problemFrequencys, problemTypes, problemStatus, faultLevels } from '@/utils/dictionary';

export default {
  name: 'DiffItemRenderer',
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    previewText: {
      type: String,
      default: '查看详情'
    }
  },
  data() {
    return {
      problemUrgencys,
      problemChannels,
      problemFrequencys,
      problemTypes,
      problemStatus,
      faultLevels
    };
  },
  computed: {
    formatArrayValue() {
      if (!this.value || this.value.length === 0) return '--';
      return this.value.map(item => item.name).join('; ');
    }
  },
  methods: {
    onPreview() {
      this.$emit('preview', this.value, this.type);
    }
  }
};
</script>

<style lang="less" scoped>
.diff-item-renderer {
  .ant-tag {
    margin: 2px 0;
  }
}
</style>
